var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-button",class:[
    { enabled: _vm.enabled },
    { selected: _vm.selected },
    { incorrect: !_vm.isValid },
    {'error-bouncing': _vm.isBouncing},
    _vm.size
  ],on:{"click":_vm.onChange}},[_c('span',{staticClass:"check-icon",style:(_vm.styles)}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }